<form class="form-signin" (ngSubmit)="login(userName.value, password.value)">

  <div class="row">
    <h2>Anmelden</h2>
    <div>
      <label for="inputEmail" class="sr-only" i18n>Benutzername</label>
      <input #userName type="text" id="inputEmail" class="form-control"  i18n-placeholder placeholder="Benutzername" required="" autofocus="">
    </div>

    <div>
      <label for="inputPassword" class="sr-only" i18n>Passwort</label>
      <input #password type="password" id="inputPassword" class="form-control" i18n-placeholder placeholder="Passwort" required="">
    </div>

    <div>
      <button class="" type="submit" i18n>Anmelden</button>
    </div>

    <div>{{errorMessage}}</div>

  </div>

</form>
